// popoverUtils.js
import { createElement } from 'lwc';
import sldsPopoverStatic from 'x/sldsPopoverStatic';
import sldsModalPop from 'x/sldsModalPop';
import sldsModalForm from 'x/sldsModalForm';




/* Display a simple popover with  one input and okay/cancel button
export function showPopover(triggerElement, publicProperties, eventListeners, existingPopover) {
    // Compute the bounding rectangle of the trigger element.
    const rect = triggerElement.getBoundingClientRect();
    let popover = existingPopover;
    
    // Create the popover component if it doesn't exist.
    if (!popover) {
        popover = createElement('x-slds-popover-static', {
            is: sldsPopoverStatic
        });
        
        // Set public properties.
        if (publicProperties) {
            Object.keys(publicProperties).forEach(key => {
                popover[key] = publicProperties[key];
            });
        }
        
        // Attach event listeners.
        if (eventListeners) {
            Object.keys(eventListeners).forEach(eventName => {
                popover.addEventListener(eventName, eventListeners[eventName]);
            });
        }
    }

    // Append the popover to the document body if it's not already attached.
    if (!popover.parentNode) {
        document.body.appendChild(popover);
    }   

    // TODO: Adjust based on Nubin
    // const nubinType = publicProperties.hasOwnProperty('nubin') ? publicProperties.nubin : 'top';
    // let nubinAdjustVertical = 15;
    // let nubinAdjust = 150;
    


    // Position the popover relative to the trigger element.
    popover.style.position = 'absolute';
    popover.style.top = `${rect.bottom + 15 + window.scrollY}px`;
    popover.style.left = `${rect.left + window.scrollX}px`;
    popover.classList.add('visible');

    return popover;
}


export function showPopover(triggerElement, publicProperties, eventListeners, existingPopover) {
    const rect = triggerElement.getBoundingClientRect();
    let popover = existingPopover;

    const nubinType = publicProperties?.nubin || 'top';

    if (!popover) {
        popover = createElement('x-slds-popover-static', {
            is: sldsPopoverStatic
        });

        if (publicProperties) {
            Object.keys(publicProperties).forEach(key => {
                popover[key] = publicProperties[key];
            });
        }

        if (eventListeners) {
            Object.keys(eventListeners).forEach(eventName => {
                popover.addEventListener(eventName, eventListeners[eventName]);
            });
        }
    }

    if (!popover.parentNode) {
        document.body.appendChild(popover);
    }

    // Prep styles so it's measurable
    popover.style.position = 'absolute';
    popover.style.visibility = 'hidden';
    popover.style.display = 'block';

    // Wait for DOM update before measuring and placing
    requestAnimationFrame(() => {
        const popoverRect = popover.getBoundingClientRect();

        const [horizontal, vertical] = nubinType.split('-');

        let top = 0;
        let left = 0;

        switch (nubinType) {
            case 'top-left':
                top = rect.bottom + 15 + window.scrollY;
                left = rect.left + window.scrollX;
                break;

            case 'top-right':
                top = rect.bottom + 15 + window.scrollY;
                left = rect.right - popoverRect.width + window.scrollX;
                break;

            case 'bottom-left':
                top = rect.top - popoverRect.height - 15 + window.scrollY;
                left = rect.left + window.scrollX;
                break;

            case 'bottom-right':
                top = rect.top - popoverRect.height - 15 + window.scrollY;
                left = rect.right - popoverRect.width + window.scrollX;
                break;

            case 'left-top':
                top = rect.top + window.scrollY;
                left = rect.right + 15 + window.scrollX;
                break;

            case 'left-bottom':
                top = rect.bottom - popoverRect.height + window.scrollY;
                left = rect.right + 15 + window.scrollX;
                break;

            case 'right-top':
                top = rect.top + window.scrollY;
                left = rect.left - popoverRect.width - 15 + window.scrollX;
                break;

            case 'right-bottom':
                top = rect.bottom - popoverRect.height + window.scrollY;
                left = rect.left - popoverRect.width - 15 + window.scrollX;
                break;

            default:
                top = rect.bottom + 15 + window.scrollY;
                left = rect.left + window.scrollX;
                break;
        }

        popover.style.top = `${top}px`;
        popover.style.left = `${left}px`;
        popover.style.visibility = 'visible';
        popover.classList.add('visible');
    });

    return popover;
}



*/

export function showPopover(triggerElement, publicProperties, eventListeners, existingPopover) {
    if (!(triggerElement instanceof HTMLElement) || !triggerElement.isConnected) {
        console.warn('Invalid or disconnected triggerElement passed to showPopover');
        return;
    }

    let popover = existingPopover;
    const nubinType = publicProperties?.nubin || 'top';

    if (!popover) {
        popover = createElement('x-slds-popover-static', {
            is: sldsPopoverStatic
        });

        if (publicProperties) {
            Object.keys(publicProperties).forEach(key => {
                popover[key] = publicProperties[key];
            });
        }

        if (eventListeners) {
            Object.keys(eventListeners).forEach(eventName => {
                popover.addEventListener(eventName, eventListeners[eventName]);
            });
        }
    }

    if (!popover.parentNode) {
        document.body.appendChild(popover);
    }
    

    // Force absolute positioning and prepare it for measurement
    Object.assign(popover.style, {
        position: 'absolute',
        visibility: 'hidden',
        display: 'block',
        zIndex: 9999 // Make sure it's on top
    });

    // Double rAF to ensure DOM layout is up to date
    requestAnimationFrame(() => {
        const rect = triggerElement.getBoundingClientRect();
        const popoverRect = popover.getBoundingClientRect();

        if (rect.width === 0 && rect.height === 0) {
            console.warn('Trigger element has no size — popover position may be invalid');
        }

        let top = 0;
        let left = 0;

        switch (nubinType) {

            case 'left': 
                top  = rect.top + (rect.height - popoverRect.height) / 2 + window.scrollY;
                left = rect.right + 8 + window.scrollX;
                break;

            case 'right':
                top  = rect.top + (rect.height - popoverRect.height) / 2 + window.scrollY; 
                left = rect.left - popoverRect.width - 8 + window.scrollX;
                break;

            case 'top-left':
                top = rect.bottom + window.scrollY;
                left = rect.left + window.scrollX;
                break;
            case 'top-right':
                top = rect.bottom + window.scrollY;
                left = rect.right - popoverRect.width + window.scrollX;
                break;
            case 'bottom-left':
                top = rect.top - popoverRect.height + window.scrollY;
                left = rect.left + window.scrollX;
                break;
            case 'bottom-right':
                top = rect.top - popoverRect.height + window.scrollY;
                left = rect.right - popoverRect.width + window.scrollX;
                break;
            case 'left-top':
                top = rect.top + window.scrollY;
                left = rect.right + window.scrollX;
                break;
            case 'left-bottom':
                top = rect.bottom - popoverRect.height + window.scrollY;
                left = rect.right + window.scrollX;
                break;
            case 'right-top':
                top = rect.top + window.scrollY;
                left = rect.left - popoverRect.width + window.scrollX;
                break;
            case 'right-bottom':
                top = rect.bottom - popoverRect.height + window.scrollY;
                left = rect.left - popoverRect.width + window.scrollX;
                break;
            default:
                top = rect.bottom + window.scrollY;
                left = rect.left + window.scrollX;
                break;
        }

        popover.style.top = `${top}px`;
        popover.style.left = `${left}px`;
        popover.style.visibility = 'visible';
        popover.classList.add('visible');
    
    });

    return popover;
}


export function disableTabbingOutside(popover) {
    try {
        if (!(popover instanceof HTMLElement)) {
            console.warn('disableTabbingOutside called with non-DOM element:', popover);
            return;
        }

        const all = document.querySelectorAll('[tabindex]');
        for (const el of all) {
            if (!popover.contains(el)) {
                el.dataset.prevTabindex = el.getAttribute('tabindex');
                el.setAttribute('tabindex', '-1');
            }
        }
    
    } catch(err) {
        console.err('Error in disableTabbingOutside() of PopoverUtils.js: ', err);
    }
}

export function restoreTabbing() {
    try {
        const all = document.querySelectorAll('[data-prev-tabindex]');
        for (const el of all) {
            el.setAttribute('tabindex', el.dataset.prevTabindex);
            delete el.dataset.prevTabindex;
        }
    
    } catch(err) {
        console.err('Error in restoreTabbing() of PopoverUtils.js: ', err);
    }
}


// Display <x-slds-modal-pop> (basic simple input modal --> usually just a quick statement along with an 'OK'/'Cancel' input)
export function showModal(publicProperties = {}) {
    console.log(JSON.stringify(publicProperties));
     for (const k of Object.keys(publicProperties)) {
        if (k === 'fields') {
            console.log('Here are the fields in showModal(): ', JSON.stringify(publicProperties[k]));
        }
    }
    return new Promise(resolve => {
        const popModal = createElement('x-slds-modal-pop', { is: sldsModalPop });
        Object.entries(publicProperties).forEach(([k, v]) => popModal[k] = v);
  
        const onConfirm = e => {
            // 1) Clone the Proxy into a plain object
            const payload = JSON.parse(JSON.stringify(e.detail));
      
            cleanup();
            // 2) resolve with the plain object
            resolve(payload);
        };
        const onCancel = () => {
            cleanup();
            resolve(null);
        };
  
        popModal.addEventListener('confirm', onConfirm);
        popModal.addEventListener('cancel',  onCancel);
    
        document.body.appendChild(popModal);
    
        function cleanup() {
            popModal.removeEventListener('confirm', onConfirm);
            popModal.removeEventListener('cancel',  onCancel);
            popModal.parentNode.removeChild(popModal);
        }
    });
}

// Display <x-slds-modal-form> (A new record form modal)
export function showFormModal(publicProperties = {}) {
    try {
        return new Promise(resolve => {
            // 1) Create the modal element
            const modal = createElement('x-slds-modal-form', {
                is: sldsModalForm
            });

            // 2) Assign all @api props
            Object.entries(publicProperties).forEach(([key, value]) => {
                modal[key] = value;
            });

            setTimeout(() => {
                modal.focusMe();
            }, 60);
            // 3) Listen for the single “formmodalclick” event
            const onModalClick = e => {
                cleanup();
                // e.detail is either 'cancel' or your fieldForm object
                resolve(e.detail);
            };
            modal.addEventListener('formmodalclick', onModalClick);

            // 4) Insert into the page
            document.body.appendChild(modal);

            // 5) Cleanup helper
            function cleanup() {
                modal.removeEventListener('formmodalclick', onModalClick);
                if (modal.parentNode) {
                    modal.parentNode.removeChild(modal);
                }
            }
        });
    
    }catch(error) {
        console.error('popoverUtils --> showFormModal()', error)
    }
}



export function positionMenuDropdownPopover(dropdownButton, container, dropdownMenu, isLeft=false) {
    const btnRect       = dropdownButton.getBoundingClientRect();
    const scrollX       = window.pageXOffset || window.scrollX || 0;
    const scrollY       = window.pageYOffset || window.scrollY || 0;
    const absoluteLeft  = btnRect.left   + scrollX;
    const absoluteRight = btnRect.right  + scrollX;
    const absoluteBottom= btnRect.bottom + scrollY;

    dropdownMenu.style.position = 'absolute';
    let left, top;

    if (container) {
        const ctrRect = container.getBoundingClientRect();
        top  = absoluteBottom - ctrRect.top;
        const menuWidth = dropdownMenu.offsetWidth;
        if (isLeft) {
            left = absoluteLeft - ctrRect.left;
        } else {
            left = absoluteRight - ctrRect.left;
        }
    } else {
        top  = absoluteBottom;
        const menuWidth = dropdownMenu.offsetWidth;
        if (isLeft) {
            left = absoluteLeft;
        } else {
            left = absoluteRight +18;
        }
    }

    dropdownMenu.style.top  = `${top}px`;
    dropdownMenu.style.left = `${left}px`;
    return dropdownMenu;
}

export function positionMenuDropdownPopoverV2(btn, menu, isLeft = false, gap = 4) {
    // Force a clean baseline so SLDS doesn't offset us
    menu.style.position = 'fixed';
    menu.style.visibility = 'hidden';
    menu.style.top = '0px';
    menu.style.left = '0px';
    menu.style.right = 'auto';
    menu.style.transform = 'none';   // 👈 kill any centering transforms
    menu.style.margin = '0';         // 👈 ignore SLDS margins while computing

    const place = () => {
        const b = btn.getBoundingClientRect();          // measure AFTER paint too
        const m = menu.getBoundingClientRect();

        let top = Math.round(b.bottom + gap);
        let left = isLeft ? Math.round(b.left) : Math.round(b.right - m.width);

        // keep on-screen
        left = Math.max(8, Math.min(left, window.innerWidth - m.width - 8));
        
        if (top + m.height > window.innerHeight - 8) {
            top = Math.max(8, Math.round(b.top - gap - m.height));
        }

        menu.style.top = `${top}px`;
        menu.style.left = `${left}px`;
        menu.style.visibility = 'visible';

        // optional: restore a small visual margin-top after positioning
        // menu.style.marginTop = '4px';
    };

    // Position after paint to get correct size
    requestAnimationFrame(place);
}
